import React, { Component } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import withRouter from '../../components/withRouter/withRouter';
import { connect } from 'react-redux';
import actions from './redux/action';
import {
  requestLogout,
  requsetGetProfile,
  requsetGetSubscription,
  googleCallback,
  checkGoogleSafe,
  getIp,
} from './api/apis';
import Header from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
import ToolsPurchaseModal from '@/components/toolsPurchaseModal/toolsPurchaseModal';
import LeavePurchaseModal from '@/components/leavePurchaseModal/index';
import EnhancePack from '@/components/enhancerPackDialog/index';
import BasicModal from '@/components/basicModal/BasicModal';
import LoadingPage from '@/components/loading/Loading';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import Security from './components/security/security';
import { message } from 'antd';
import cartUrl from '@/views/account/utils/cartUrl';
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      linkToPersonalCenter: false, //是否跳转到个人中心
      linkToLogin: false, //是否跳转到登录
      linkToPurchase: false, //是否跳转到购买链接
      isSecurity: false,
      submitLoading: false,
      googleID: '',
      //登出确认弹窗信息
      basicModalObj: {
        visible: false,
        content: this.props.t('loginAndSignUp:logoutWarnTips'),
        onCancel: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
        },
        onOk: () => {
          const basicModalObj = { ...this.state.basicModalObj };
          basicModalObj.visible = false;
          this.setState({
            basicModalObj,
          });
          this.handleLogout();
        },
      },
      loadding: true, //当前是否正在载入
      headerUrl: '',
    };
  }
  getQueryVariable(variable) {
    var query = this.props.urlSearch.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  handleCancel() {
    if (Cookies.get('authorization')) {
      this.initUserInfo();
    } else {
      this.setState({ loadding: false });
      let url = window.location.href.split('?')[0];
      window.location.href = url;

      // 进入个人中心相关页面才需要跳转登录，付费不需要
      // if (window.location.hash.match(/personal-center/)) {
      //   this.handleNavigationToLogin();
      // }
    }
  }
  componentDidMount() {
    const code = this.getQueryVariable('code');
    const state = this.getQueryVariable('state');
    if (code && state) {
      this.setState(() => {
        this.setState({
          loadding: true,
        });
      });
      let url = window.location.href.split('?')[0];
      window.location.href = url;
      googleCallback({ code: code, state: state })
        .then((obj) => {
          if (obj.code == 200) {
            Cookies.set('authorization', obj.data.authorization, {
              expires: 30,
            });
            let hostName = window.location.hostname;
            Cookies.set('access_token', obj.data.account_access_token, {
              expires: 30,
              domain: hostName.substring(
                hostName.indexOf('.'),
                hostName.length
              ),
            });
            let expires_in = new Date().getTime() + 30 * 86400 * 1000;
            Cookies.set('access_token_expires_in', expires_in.toString(), {
              expires: 30,
              domain: hostName.substring(
                hostName.indexOf('.'),
                hostName.length
              ),
            });
            this.props.onAuthorizationChange(obj.data.authorization);
            if (localStorage.getItem('redirect')) {
              let res = localStorage.getItem('redirect');
              localStorage.removeItem('redirect');
              window.location.href = res;
            } else {
              this.initUserInfo();
            }
          }
          if (obj.code === 403101) {
            this.setState({
              isSecurity: true,
              googleID: obj.data.id,
              email: obj.data.email,
            });
            console.log(this.state.googleID, obj);
          }
          if (obj.code === 403102) {
            this.setState({
              loadding: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loadding: false,
          });
        });
    }
    setTimeout(() => {
      this.isAddCartParms();
    }, 0);

    if (Cookies.get('authorization')) {
      this.initUserInfo();
    } else {
      // 进入个人中心相关页面才需要跳转登录，付费不需要
      if (window.location.hash.match(/personal-center/)) {
        this.handleNavigationToLogin();
      }
      this.setState({ loadding: false });
    }
  }

  /**
   * 跳转到当前个人中心
   */
  handleNavigationToPersonalCenter = () => {
    this.setState(
      {
        linkToPersonalCenter: true,
      },
      () =>
        this.setState({
          linkToPersonalCenter: false,
        })
    );
  };

  /**
   * 跳转到登录
   */
  handleNavigationToLogin = () => {
    this.setState(
      {
        linkToLogin: true,
      },
      () =>
        this.setState({
          linkToLogin: false,
        })
    );
  };

  /**
   * 跳转到购买页面
   */
  handleNavigationToPurchase = () => {
    this.setState(
      {
        linkToPurchase: true,
      },
      () =>
        this.setState({
          linkToPurchase: false,
        })
    );
  };

  /**
   * 初始化用户信息
   */
  initUserInfo = () => {
    this.handleRequsetGetProfile();
    this.handleGetSubscription();
    this.handleGetIp();
  };

  /**
   *请求获取用户信息
   */
  handleRequsetGetProfile = () => {
    requsetGetProfile()
      .then((res) => {
        if (res.code === 200) {
          this.props.onProfileObjChange(res.data);
          if (!window.location.hash.match(/personal-center|\/purchase/)) {
            this.handleNavigationToPersonalCenter();
          }
        }
        // else if (res.code === 401) {
        //   //认证码过期
        //   // localStorage.removeItem("authorization");
        //   Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
        //   this.handleNavigationToLogin();
        // }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loadding: false });
      });
  };
  /**
   * 获取用户ip去显示文案
   */
  handleGetIp() {
    getIp()
      .then((res) => {
        if (res.code === 200) {
          let ip = res.data.ip;
          let ip1 = ip.split('.');
          let user = '';
          ip = ip1[ip1.length - 1];
          if (ip % 2 === 0) {
            //判定条件余数为0时为偶数
            localStorage.setItem('userIp', 'B');
          } else {
            localStorage.setItem('userIp', 'A');
          }
          console.log('ip:', ip, user);
        }
        // else if (res.code === 401) {
        //   //认证码过期
        //   // localStorage.removeItem("authorization");
        //   Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
        //   this.handleNavigationToLogin();
        // }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  /**
   *  退出登录
   */
  handleLogout = () => {
    this.props.onProfileObjChange(null);
    this.props.onSubscriptionChange(null);
    let hostName = window.location.hostname;
    Cookies.remove('authorization');
    Cookies.remove('access_token', {
      domain: hostName.substring(
        window.location.hostname.indexOf('.'),
        hostName.length
      ),
    });
    Cookies.remove('access_token_expires_in', {
      domain: hostName.substring(hostName.indexOf('.'), hostName.length),
    });
    // 购买页退登后无需跳登录
    let isPurchasePage = window.location.hash.match(/\purchase/);
    if (!isPurchasePage) {
      this.handleNavigationToLogin();
    }

    requestLogout()
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   *获取用户订阅信息
   */
  handleGetSubscription = () => {
    requsetGetSubscription()
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.props.onSubscriptionChange(res.data.subscription);
          if (res.data.subscription == null) {
            this.handleLoginRedirect(false);
          } else if (res.data.subscription.length > 0) {
            let result = res.data.subscription.filter((item) => {
              return item.product_name == 'HitPaw Online';
            });
            if (result.length == 0) {
              this.handleLoginRedirect(false);
            } else {
              if (result[0].status == 'Active') {
                this.handleLoginRedirect(true);
              } else {
                this.handleLoginRedirect(false);
              }
            }
          }
          // this.handleLoginRedirect(res.data.subscription && res.data.subscription.status === "Active" ? true : false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   *控制用户登录完毕登录后的跳转链接
   * @param {Boolean} isVIP 当前用户是不是VIP（非必填）
   */
  handleLoginRedirect = (isVIP) => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get('redirect');
    const to = urlParams.get('to');
    if (urlParams.has('redirect')) {
      if (redirect && to === 'purchase' && !isVIP) {
        console.log('购买链接');
        this.handleNavigationToPurchase();
      } else if (
        (redirect && !to) ||
        (redirect && to === 'purchase' && isVIP)
      ) {
        console.log('直接重定向到上一个链接');
        window.location.replace(redirect);
      }
    } else {
      console.log('跳转到某个链接');
      if (!window.location.hash.match(/personal-center|\/purchase/)) {
        this.handleNavigationToPersonalCenter();
      }
    }
  };

  //判断点击个人中心的头部，是否需要加上购物车参数
  isAddCartParms() {
    let urlParam = '';
    if (window.location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      urlParam = this.getUrlParam(location.href);
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      urlParam = obj;
    }

    const url = `track[type]=${urlParam['track[type]']}&track[sid]=${urlParam['track[sid]']}&track[func]=${urlParam['track[func]']}&track[reason]=${urlParam['track[reason]']}&track[host]=${urlParam['track[host]']}&track[platform]=${urlParam['track[platform]']}&track[ab]=${urlParam['track[ab]']}&track[channel]=${urlParam['track[channel]']}&track[discount]=${urlParam['track[discount]']}`;
    this.headerUrl = url;
  }

  getUrlParam = (url) => {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1];
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&');
    for (let i = 0, len = paramsArr.length; i < len; i++) {
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=');
      obj[arr[0]] = arr[1];
    }
    return obj;
  };

  render() {
    const currentPath = this.props.location.pathname;
    console.log('sdlkfjlsdkjfsld', currentPath);
    return (
      <>
        {this.state.linkToPersonalCenter && (
          <Navigate to='./personal-center/profile' replace={true} />
        )}
        {this.state.linkToLogin && <Navigate to='./login' replace={true} />}
        {this.state.linkToPurchase && (
          <Navigate to={`/purchase${this.props.urlSearch}`} replace={true} />
        )}
        {currentPath != '/login' && currentPath != '/signUp' ? (
          <Header
            profileObj={this.props.profileObj}
            subscription={this.props.subscription}
            headerUrl={this.headerUrl}
            handleLogout={() => {
              const basicModalObj = { ...this.state.basicModalObj };
              basicModalObj.visible = true;
              this.setState({
                basicModalObj,
              });
            }}
          />
        ) : (
          ''
        )}

        {this.state.loadding ? <LoadingPage /> : <Outlet />}
        {currentPath != '/login' && currentPath != '/signUp' ? <Footer /> : ''}

        <BasicModal {...this.state.basicModalObj} />
        <ToolsPurchaseModal />
        <LeavePurchaseModal />
        <EnhancePack />
        <Security
          email={this.state.email}
          googleID={this.state.googleID}
          visible={this.state.isSecurity}
          handleCancel={() => {
            this.setState({
              isSecurity: false,
            });
            this.handleCancel();
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
  authorization: state.account.authorization,
});
const mapDispatchToProps = (dispatch) => ({
  onProfileObjChange: (profileObj) =>
    dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: (authorization) =>
    dispatch(actions.onAuthorizationChange(authorization)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
  getAllSubscription: (subscription) =>
    dispatch(actions.getAllSubscription(subscription)),
});

export default withTranslation(['common', 'loginAndSignUp'])(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
);
